export default class {

    constructor() {
        this.player = false
    }

    mount() {
        window.addEventListener('primisPlayerInit', this.setPlayerOnInit.bind(this))
        window.addEventListener('menutoggle', this.handleMenuToggle.bind(this))
        window.addEventListener('menushown', this.handleMenuShown.bind(this))
    }

    handleMenuToggle(e) {
        if (!this.player) {
            return
        }

        this.player.float(e.detail.open ? 'disable' : 'enable')
    }

    handleMenuShown(e) {
        if (!this.player) {
            return
        }

        this.player.float(e.detail.shown ? 'disable' : 'enable')
    }

    setPlayerOnInit(e) {
        if (e.detail.playerApiId === 'PrimaryPlayer') {
            this.player = e.detail
        }
    }

}
